import React, { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { FormSelect, useZionFormContext } from '@fs/zion-form'
import { useStates } from '../../hooks'

export const NAME = 'province'

export const StateField = ({ disabled, value }) => {
  const [t] = useTranslation()
  const { states } = useStates()

  const options = useMemo(() => states.map(({ display: { name } }) => ({ label: name, value: name })), [states])

  const { setValue } = useZionFormContext()

  useEffect(() => {
    if (value && states) setValue(NAME, value)
  }, [setValue, states, value])

  return (
    <FormSelect
      name={NAME}
      label={`${t('form.field.state.label', 'State')} *`}
      options={options}
      disabled={disabled}
      required
    />
  )
}
